import { render, staticRenderFns } from "./FileInfo.vue?vue&type=template&id=0d39e4dc&scoped=true&"
import script from "./FileInfo.vue?vue&type=script&lang=js&"
export * from "./FileInfo.vue?vue&type=script&lang=js&"
import style0 from "./FileInfo.vue?vue&type=style&index=0&id=0d39e4dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d39e4dc",
  null
  
)

export default component.exports